<template>
    <div>
        <Modal
                @on-visible-change="visibleChange"
                class="dosion-accessory"
                v-model="selectAccessoryModal"
                title="选择附件"
                :loading="true"
                width="1100"
                height="600" footer-hide>
            <Row>
                <Col span="6">
                    <Card style="width:273px;height: 600px;overflow: auto;" shadow>
                        <p slot="title">
                            附件分类
                        </p>
                        <Button @click="addFolder(null)" slot="extra" icon="md-add" type="primary" shape="circle">新增
                        </Button>
                        <el-tree :data="folderList" :props="defaultProps" default-expand-all highlight-current
                                 :expand-on-click-node="false" @node-click="treeClick">
           <span class="forder-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.id!=0">
              <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-edit"
                      @click.stop="addFolder(data)">
              </el-button>
              <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-delete"
                      @click.stop="delFolder(data)">
              </el-button>
            </span>
           </span>
                        </el-tree>
                    </Card>
                </Col>
                <Col span="18">
                    <Card style="width:825px;height: 600px;" shadow>

                        <Spin size="large" fix v-if="loading">
                            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                            加载中...
                        </Spin>
                        <p slot="title">
                            {{typeTitle}}
                            <!-- <el-checkbox v-model="isSelectAll" @change="selectAll" style="margin-left: 20px">全选
                             </el-checkbox>-->
                        </p>
                        <a slot="extra">
                            <div v-if="selectAccessoryList!=null&&selectAccessoryList.length>0">
                                <Button type="text" @click="clearSelect">取消选择</Button>
                                <Button icon="md-trash" type="error" shape="circle" @click="batchDelete">删除附件</Button>
                            </div>
                            <div v-else>
                                <Input v-model="query.original" type="text" suffix="ios-search" search
                                       @on-search="getFile"
                                       placeholder="请输入名称搜索" style="width: auto;margin-right: 10px"/>
                                <el-upload
                                        :action="uploadUrl()"
                                        :show-file-list="false"
                                        :data="uploadData"
                                        :before-upload="beforeUpload"
                                        :on-error="errorUpload"
                                        :headers="uploadHeader"
                                        multiple
                                        :on-success="handleAvatarSuccess" style="display: inline;">
                                    <Button icon="ios-cloud-upload-outline" type="primary" shape="circle">上传附件</Button>
                                </el-upload>
                            </div>
                        </a>
                        <div style="height: 510px;overflow: auto">
                            <el-checkbox-group v-model="selectAccessoryList">
                                <el-table
                                        :data="fileList"
                                        size="mini"
                                        style="width: 100%">
                                    <el-table-column
                                            label="附件名称" prop="title">
                                        <template slot-scope="scope">
                                            <el-checkbox :label="scope.row.id">
                                                <span v-text="scope.row.name"></span>
                                            </el-checkbox>
                                        </template>

                                    </el-table-column>

                                    <el-table-column label="操作" width="200" align="center">
                                        <template slot-scope="scope">
                                            <Icon type="md-download"
                                                  style="font-size: 16px;cursor: pointer;margin-right: 5px"
                                                  @click="download(scope.row)"/>
                                            <Icon type="md-trash" style="font-size: 16px;cursor: pointer"
                                                  @click="delAccessory(scope.row)"/>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-checkbox-group>

                            <div style="clear: both"></div>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Page style="float: left;margin-top: 5px;margin-left: 10px" v-if="count>0" transfer @on-change="pageChange"
                  @on-page-size-change="sizeChange"
                  :page-size="12"
                  :page-size-opts="[12,24,48,96]"
                  prev-text="上一页"
                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>
            <Button v-if="!hiedOk" @click="okSelect" type="primary" style="float: right;margin: 10px">确定</Button>
            <p v-if="selectAccessoryList!=null&&selectAccessoryList.length>0"
               style="float: right;margin: 10px;line-height: 30px">已选择
                <span style="color: #ed4014">{{selectAccessoryList.length}}</span> 个附件</p>
            <div style="clear: both"></div>
        </Modal>
    </div>
</template>
<style>
    .dosion-accessory .ivu-modal-body {
        padding: 0px !important;
    }

    .dosion-accessory .ivu-card-extra {
        top: 8px;
    }

    .forder-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
</style>
<script>
    import {addFolder, delFolder, folderList, updateFolder} from '@/api/system/folder'
    import {batchDeleteFile, fetchList} from '@/api/system/file'
    import dataUtils from '@/utils/dataUtils';
    import appUtils from '@/utils/appUtils';
    import Setting from '@/setting';

    export default {
        components: {},
        name: 'dosion-accessory',
        props: {
            value: {
                type: Boolean
            },
            hiedOk: {
                type: Boolean
            }
        },
        data() {
            return {
                loading: false,//加载中
                site: {},//站点信息
                typeTitle: '全部分类',//分类标题
                folderList: [],//文件夹列表
                selectForder: {},//选择的文件夹
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                fileList: [],//文件列表
                uploadData: {
                    'fileType': '3'
                },
                uploadHeader: {
                    Authorization: 'Bearer ' + dataUtils.getData(Setting.key.token)
                },
                selectAccessoryList: [],//选中的附件
                isSelectAll: false,//是否全选
                query: {
                    'folderId': null,
                    'original': null,
                    'type': 'FILE',
                    current: 1, // 当前页数
                    size: 12 // 每页显示多少条
                },
                selectAccessoryModal: false,
                count: 0
            }
        },
        watch: {
            selectAccessoryList() {
                if (this.selectAccessoryList == null || this.selectAccessoryList.length <= 0) {
                    this.isSelectAll = false
                    return
                }
                if (this.selectAccessoryList.length == this.fileList.length) {
                    this.isSelectAll = true
                } else {
                    this.isSelectAll = false
                }
            },
            selectAccessoryModal(val) {
                if (val) {
                    this.selectAccessoryList = []
                    this.getFolder()
                }
            },
            value(val) {
                if (val) {
                    if (val) {
                        this.selectAccessoryModal = true
                    }
                }
            },
            deep: true
        },
        methods: {
            visibleChange(val) {
                this.$emit('input', val)
            },
            //获取附件
            getAccessory(bucketName, fileName) {
                return dataUtils.getImg(bucketName, fileName)
            },
            //上传地址
            uploadUrl() {
                return Setting.apiBaseURL + '/system/file/upload?folderId=' + this.selectForder.id
            },
            //加载文件夹
            getFolder() {
                this.loading = true
                folderList({'type': '3'}).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.folderList = [{
                            id: 0,
                            name: '全部分类',
                            children: res.data
                        }]
                        this.selectForder = this.folderList[0]
                        this.getFile()
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //获取文件
            getFile() {
                this.loading = true
                this.query.folderId = this.selectForder.id == 0 ? null : this.selectForder.id
                fetchList(this.query).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.fileList = res.data.records
                        this.count = res.data.total
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //添加文件夹
            addFolder(folder) {
                var folderModel = {
                    'type': '3',
                    'name': null
                }
                if (folder != null) {
                    var model = JSON.parse(JSON.stringify(folder))
                    folderModel.id = model.id
                    folderModel.name = model.name
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: folderModel.name,
                                autofocus: true,
                                placeholder: '请输入文件夹名称'
                            },
                            on: {
                                input: (val) => {
                                    folderModel.name = val
                                }
                            }
                        })
                    },
                    loading: true,
                    onOk: () => {
                        if (folderModel.id == null) {
                            addFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        } else {
                            updateFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        }


                    }
                })
            },
            //删除文件夹
            delFolder(folder) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定删除文件夹？</p><p style="color: red">（删除后该分类图片自动移动到全部分类下）</p>',
                    loading: true,
                    onOk: () => {
                        delFolder(folder.id).then(res => {
                            if (res.state) {
                                this.getFolder()
                                appUtils.showSuccess(res.msg)
                                this.selectAccessoryList = []
                            } else {
                                appUtils.showError(res.msg)
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //上传之前
            beforeUpload(file) {
                this.loading = true
            },
            //上传失败
            errorUpload(err, file, fileList) {
                appUtils.showError(err)
                this.loading = false
            },
            //上传成功
            handleAvatarSuccess(res, file) {
                if (res.state) {
                    appUtils.showSuccess('上传成功！')
                    this.getFile()
                } else {
                    if (res.code == 1001) {
                        dataUtils.removeAllData()
                        location.reload()
                    } else {
                        appUtils.showError(res.msg)
                    }
                }
            },
            //树节点点击
            treeClick(data, node, el) {
                if (this.selectForder.id != data.id) {
                    this.selectForder = data
                    this.typeTitle = data.name
                    this.getFile()
                    this.selectAccessoryList = []
                }
            },
            //取消附件选择
            clearSelect() {
                this.selectAccessoryList = []
            },
            //批量删除
            batchDelete() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定删除选择的附件？',
                    loading: true,
                    onOk: () => {
                        if (this.selectAccessoryList == null || this.selectAccessoryList.length <= 0) {
                            appUtils.showError('请选择要删除的附件！')
                            return
                        }
                        batchDeleteFile(this.selectAccessoryList.toString()).then(res => {
                            if (res.state) {
                                appUtils.showSuccess('删除附件成功！')
                                this.getFile()
                                this.selectAccessoryList = []
                            } else {
                                appUtils.showError('删除附件失败！')
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //确认选择
            okSelect() {
                var selectAccessory = []
                dataUtils.each(this.selectAccessoryList, (k, o) => {
                    var arr = this.fileList.filter(t => t.id == o)
                    if (arr != null && arr.length > 0) {
                        selectAccessory.push(arr[0])
                    }
                })
                this.$emit('select', selectAccessory)
                this.selectAccessoryList = []
                this.selectAccessoryModal = false
            },
            //全选
            selectAll(val) {
                this.selectAccessoryList = []
                dataUtils.each(this.fileList, (key, obj) => {
                    this.selectAccessoryList.push(obj.id)
                })
            },
            //删除附件
            delAccessory(row) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定删除附件？',
                    loading: true,
                    onOk: () => {
                        batchDeleteFile(row.id).then(res => {
                            if (res.state) {
                                appUtils.showSuccess('删除附件成功！')
                                this.getFile()
                                this.selectAccessoryList = []
                            } else {
                                appUtils.showError('删除附件失败！')
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            download(row) {
                window.open(row.url)
            },
            // 页数发生改变
            pageChange(val) {
                this.query.current = val
                this.getFile()
            },
            // 每页显示条数发生改变
            sizeChange(val) {
                this.query.size = val
                this.query.current = 1
                this.getFile()
            }
        },
        mounted() {
            //this.site = dataUtils.getData(config.key.site)
            //this.uploadData['site.id'] = this.site.id
        }
    }
</script>
